/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var DivideCircleIcon24Solid = forwardRef('DivideCircleIcon24Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10ZM7 11a1 1 0 1 0 0 2h10a1 1 0 1 0 0-2H7Zm6.498-3.5a1.498 1.498 0 1 1-2.996 0 1.498 1.498 0 0 1 2.996 0ZM12 17.998a1.498 1.498 0 1 0 0-2.997 1.498 1.498 0 0 0 0 2.997Z" })));
});
